/// <reference path="../include.ts" />

namespace project_common {

	export class BannerData {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			const banner = window['banner'] || null;
			if (banner) {
				this.guide = banner['guide'] || null;
				this.board = banner['board'] || null;
			}

			trace('[BannerData]', this);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		readonly guide:GuideBanner;
		readonly board:BoardBanner;
	}
}
